import React, { Component } from 'react';
import { ProductProperty } from '../../../api/models/ProductProperty';
import { Typography } from '@material-ui/core';

type Props = {
    prodProperties: ProductProperty[] | null | undefined
}

export class ProductPropertiesList extends Component<Props> {
    render() {
        return (
            <div>
                {this.props.prodProperties &&
                    <div>
                        {this.props.prodProperties.map((sp, i) => {
                            return <span key={i}><Typography variant="body2">{sp.name}:&nbsp;{sp.options[0].name}</Typography></span>
                        })}
                    </div>
                }
            </div>
        );
    }
}

export default ProductPropertiesList;